export default __webpack_public_path__ + "static/media/blog16.19fb90dc.jpg";